import { render, staticRenderFns } from "./PdoColInfoView.vue?vue&type=template&id=6641a858&scoped=true"
import script from "./PdoColInfoView.vue?vue&type=script&lang=js"
export * from "./PdoColInfoView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6641a858",
  null
  
)

export default component.exports